var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/text-truncate-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["text", "characterLimit"], 
["renderer", "ga_event"], 
function (l_text, l_characterLimit, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("text", l_text);
frame.set("characterLimit", l_characterLimit);
frame.set("renderer", kwargs.hasOwnProperty("renderer") ? kwargs["renderer"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("ga_event", kwargs.hasOwnProperty("ga_event") ? kwargs["ga_event"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_2 = "";t_2 += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "source") == "product") {
t_2 += "\n    ";
var t_3;
t_3 = "pdp";
frame.set("pageCategory", t_3, true);
if(frame.topLevel) {
context.setVariable("pageCategory", t_3);
}
if(frame.topLevel) {
context.addExport("pageCategory", t_3);
}
t_2 += "\n";
;
}
else {
t_2 += "\n    ";
var t_4;
t_4 = "";
frame.set("pageCategory", t_4, true);
if(frame.topLevel) {
context.setVariable("pageCategory", t_4);
}
if(frame.topLevel) {
context.addExport("pageCategory", t_4);
}
t_2 += "\n    ";
var t_5;
t_5 = "";
frame.set("brandAnalyticsSlug", t_5, true);
if(frame.topLevel) {
context.setVariable("brandAnalyticsSlug", t_5);
}
if(frame.topLevel) {
context.addExport("brandAnalyticsSlug", t_5);
}
t_2 += "\n";
;
}
t_2 += "\n\n";
var t_6;
t_6 = (lineno = 24, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.analytics.productTypeSlug"]));
frame.set("brandAnalyticsSlug", t_6, true);
if(frame.topLevel) {
context.setVariable("brandAnalyticsSlug", t_6);
}
if(frame.topLevel) {
context.addExport("brandAnalyticsSlug", t_6);
}
t_2 += "\n\n<div class=\"c-text-truncate\">\n\n    ";
if(l_text && env.getFilter("length").call(context, l_text) > l_characterLimit) {
t_2 += "\n\n        <div class=\"c-text-truncate__text u-break-word\">\n                ";
t_2 += runtime.suppressValue(env.getFilter("markdown").call(context, env.getFilter("truncate").call(context, l_text,l_characterLimit,runtime.contextOrFrameLookup(context, frame, "True")),runtime.contextOrFrameLookup(context, frame, "renderer")), env.opts.autoescape);
t_2 += "\n\n            <div class=\"c-text-truncate__button--outer\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "ga_event") && runtime.contextOrFrameLookup(context, frame, "ga_event") == "description") {
t_2 += "\n                    <a ";
t_2 += runtime.suppressValue((lineno = 35, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["pdp",runtime.contextOrFrameLookup(context, frame, "brandAnalyticsSlug"),"description"])), env.opts.autoescape);
t_2 += " class=\"c-text-truncate__button js-text-truncate__toggle\">\n                        ";
t_2 += runtime.suppressValue((lineno = 36, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["text-truncate_show-more"])), env.opts.autoescape);
t_2 += "\n                    </a>\n                ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "ga_event") && runtime.contextOrFrameLookup(context, frame, "ga_event") == "review") {
t_2 += "\n                    <a ";
t_2 += runtime.suppressValue((lineno = 39, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["pdp",runtime.contextOrFrameLookup(context, frame, "brandAnalyticsSlug"),"review read more"])), env.opts.autoescape);
t_2 += " class=\"c-text-truncate__button js-text-truncate__toggle\">\n                        ";
t_2 += runtime.suppressValue((lineno = 40, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["text-truncate_show-more"])), env.opts.autoescape);
t_2 += "\n                    </a>\n                ";
;
}
else {
t_2 += "\n                    <a class=\"c-text-truncate__button js-text-truncate__toggle\">\n                        ";
t_2 += runtime.suppressValue((lineno = 44, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["text-truncate_show-more"])), env.opts.autoescape);
t_2 += "\n                    </a>\n                ";
;
}
;
}
t_2 += "\n            </div>\n\n        </div>\n\n        <div class=\"c-text-truncate__text c-text-truncate__hide u-break-word\">\n                ";
t_2 += runtime.suppressValue(env.getFilter("markdown").call(context, l_text,runtime.contextOrFrameLookup(context, frame, "renderer")), env.opts.autoescape);
t_2 += "\n\n            <div class=\"c-text-truncate__button--outer\">\n                <a class=\"c-text-truncate__button c-text-truncate__button--show-less js-text-truncate__toggle\">\n                    ";
t_2 += runtime.suppressValue((lineno = 56, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["text-truncate_show-less"])), env.opts.autoescape);
t_2 += "\n                </a>\n            </div>\n\n        </div>\n\n    ";
;
}
else {
if(l_text) {
t_2 += "\n\n        <div class=\"c-text-truncate__text u-break-word\">\n                ";
t_2 += runtime.suppressValue(env.getFilter("markdown").call(context, l_text,runtime.contextOrFrameLookup(context, frame, "renderer")), env.opts.autoescape);
t_2 += "\n        </div>\n\n    ";
;
}
;
}
t_2 += "\n\n</div>\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("truncateText");
context.setVariable("truncateText", macro_t_1);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/text-truncate-macro.j2"] , dependencies)